import { USER_URL } from "../constant/api";

// export const getCustomers = async (filter) => {
//     try {
//         const response = await USER_URL.get("/accounts/admin/allocate/customers/")
//         // console.log(response.data);
//         return response.data;
        
//     } catch (error) {
//         console.error("Error fetching customers:", error);
//         throw error;
        
//     }
// }

export const getCustomers = async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
  
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          queryParams.append(key, value);
        }
      });
  
      const response = await USER_URL.get(
        `/accounts/admin/allocate/customers/?${queryParams.toString()}`
      );
  console.log("response", response.data);
  
      return response.data;
    } catch (error) {
      console.error("Error fetching customers:", error);
      throw error;
    }
  };

export const getSubAdmins = async () => {
    try {
        const response = await USER_URL.get("/accounts/admin/all-subadmin/")
        // console.log("sub admin",response.data);
        return response.data;
        
    } catch (error) {
        console.error("Error fetching customers:", error);
        throw error;
        
    }
}

// allocate customer to subadmin

export const allocateToSubAdmin = async (data) => {
    try {
      console.log("data", data);
      
        const response = await USER_URL.post("/accounts/admin/allocate/customers/",data)
        console.log("sub admin",response.data);
        return response.data;
        
    } catch (error) {
        console.error("Error fetching customers:", error);
        throw error;
        
    }
}


export const getSellers = async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams();
  
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          queryParams.append(key, value);
        }
      });
  
      const response = await USER_URL.get(
        `/accounts/admin/allocate/sellers/?${queryParams.toString()}`
      );
  console.log("response", response.data);
  
      return response.data;
    } catch (error) {
      console.error("Error fetching customers:", error);
      throw error;
    }
  };

  // allocate seller to subadmin

export const allocateSellerToSubAdmin = async (data) => {
    try {
        const response = await USER_URL.post("/accounts/admin/allocate/sellers/",data)
        console.log("sub admin",response.data);
        return response.data;
        
    } catch (error) {
        console.error("Error fetching customers:", error);
        throw error;
        
    }
}